module.exports = __webpack_public_path__ + "static/media/techAsia.bc7fb9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/techAsia.png
// module id = 1813
// module chunks = 147